"use client";

import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_GREYSCALE_BLACK_8 } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { PRODUCTS_TOP_BAR_CLASSES } from "./constants";

export const ProductsTopBarContainer = styled(({ ...restProps }: BoxProps) => (
  <Box {...restProps} />
))(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    display: "flex",
    justifyContent: "space-between",
    [BREAKPOINT_TABLET]: {
      borderBottom: `1px solid ${COLOR_GREYSCALE_BLACK_8}`,
    },
    [BREAKPOINT_DESKTOP]: {
      borderBottom: "none",
      marginBottom: 0,
    },
    [`& .${PRODUCTS_TOP_BAR_CLASSES.openFiltersBtn}`]: {
      padding: 0,
      [BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
    [`& .${PRODUCTS_TOP_BAR_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_DESKTOP]: {
        display: "block",
      },
    },
  };
});
